import { render, staticRenderFns } from "./LocationLabReports.vue?vue&type=template&id=0fdc2c69&scoped=true&"
import script from "./LocationLabReports.vue?vue&type=script&lang=js&"
export * from "./LocationLabReports.vue?vue&type=script&lang=js&"
import style0 from "./LocationLabReports.vue?vue&type=style&index=0&id=0fdc2c69&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdc2c69",
  null
  
)

export default component.exports